export default {"src":"/_next/static/media/cmm.3de76005.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};